import { Outlet } from 'react-router-dom';

/**
 * A route wrapper that used to check whether the selected account had finished
 * onboarding and redirect to /onboard/:accountId if not.
 *
 * That check is disabled (see below), so this renders its children
 * unconditionally. It previously withheld render until `accounts` loaded,
 * which blocked first contentful paint on every workspace screen while both
 * branches went on to render the same <Outlet /> anyway.
 */
export default function RequireOnboardingComplete() {
  // Restoring the check must not reintroduce a render gate: read `accounts`
  // from UserContext and redirect once it resolves, while still rendering
  // <Outlet /> in the meantime.
  //
  // const { slug } = useParams<{ slug: string }>();
  // const { accounts } = useContext(UserContext);
  // const selectedAccount = accounts?.find((a) => a.data().slug === slug);
  // const onboardStatus = selectedAccount?.data().onboardStatus;
  //
  // if (selectedAccount && onboardStatus !== 'completed') {
  //   return <Navigate to={`/onboard/${selectedAccount.id}`} replace />;
  // }

  return <Outlet />;
}
